import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'umss-tooltip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class UmssTooltipComponent {
  constructor() {}

  /** Content props - Clean and semantic */
  @Input() text: string = 'Tooltip text';

  /** Positioning props - Well-typed and comprehensive */
  @Input() position: 'top' | 'bottom' | 'left' | 'right' = 'bottom';

  /** Styling props - Simple and flexible */
  @Input() variant: 'dark' | 'light' = 'dark';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';

  /** State props */
  @Input() visible: boolean = true; // For demo purposes, normally controlled by hover
  @Input() disabled: boolean = false;
}
